import { Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';

import { useAuth } from '../hooks';

export const LogoutButton = (props: ButtonProps) => {
  const { logout } = useAuth();
  return <Button {...props} onClick={logout} />;
};
